module.exports = __webpack_public_path__ + "static/img/4.40ea2fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Todo-riesgo-empresarial/4.png
// module id = gDbh
// module chunks = 0